<template>
  <form @submit.prevent="$emit('next')" class="selling-data">
    <div v-if="form.status !== 'draft'">
      <snow-select
        v-model="form.status"
        label="Status de Vendas"
        id="sale-status"
        :options="[
          { id: 'active', name: 'Ativas' },
          { id: 'inactive', name: 'Suspensas' }
        ]"
      />
    </div>

    <snow-input
      v-model="form.email_support"
      id="email_support"
      label="E-mail de suporte ao cliente"
      type="email"
    />

    <div class="bg-5 d-flex p-4 rounded-16 gap-2">
      <i class="ph ph-warning-circle fs-18" />
      <div>
        <div class="fs-14">Atenção</div>
        <div class="text-dark-40 fs-12">
          Insira um nome que descreva seu produto para evitar chargebacks.
        </div>
      </div>
    </div>

    <snow-input
      v-model="form.statement_descriptor"
      id="statement_descriptor"
      label="Nome na fatura"
      type="name"
      maxlength="13"
    />

    <h5 class="text-semibold">Simulação da fatura</h5>

    <div class="d-flex">
      <div class="card-simulation">
        <span class="text-dark-40 fs-14">23/02/2021</span>
        <div class="d-flex mt-4 text-semibold">
          <span class="mr-7">
            {{ $config.get("title") }}* {{ form.statement_descriptor }}
          </span>
          <span>R$ 189,90</span>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
.selling-data {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .card-simulation {
    display: flex;
    flex-direction: column;
    background: var(--bg-1);
    padding: 24px;
    border-radius: 16px;
    border: 1px solid var(--dark-10);
  }
}
</style>
